import { render, staticRenderFns } from "./TransList.vue?vue&type=template&id=0135a8b2&scoped=true&"
import script from "./TransList.vue?vue&type=script&lang=js&"
export * from "./TransList.vue?vue&type=script&lang=js&"
import style0 from "./TransList.vue?vue&type=style&index=0&id=0135a8b2&lang=scss&scoped=true&"
import style1 from "./TransList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0135a8b2",
  null
  
)

export default component.exports